import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import ClearAllIcon from '@mui/icons-material/ClearAll';

/**
 * Control buttons for the mapping diagram
 * Provides undo and clear functionality
 */
const MappingControls = ({
  onUndo,
  onClear,
  canUndo = false,
  canClear = false,
  disabled = false,
  size = 'small',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        justifyContent: 'flex-end',
        mb: 1,
      }}
    >
      <Tooltip title="Undo last action">
        <span>
          <Button
            variant="outlined"
            size={size}
            onClick={onUndo}
            disabled={disabled || !canUndo}
            startIcon={<UndoIcon />}
          >
            Undo
          </Button>
        </span>
      </Tooltip>
      <Tooltip title="Clear all connections">
        <span>
          <Button
            variant="outlined"
            size={size}
            onClick={onClear}
            disabled={disabled || !canClear}
            startIcon={<ClearAllIcon />}
            color="warning"
          >
            Clear
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default MappingControls;
